var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticStyle:{"width":"100%"}},[_c('el-row',{staticStyle:{"padding":"5px 0"}},[_c('el-col',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"span":24}},[_c('span',{staticClass:"no-results-available"},[_vm._v(_vm._s(_vm.bannerText))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3014fda6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/noResultsBanner.vue
// module id = null
// module chunks = 